import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import {
  activeRangeSet,
  activeScopeSet,
  activeSessionSet,
  selectActiveRange,
  selectActiveScope,
  selectActiveSession,
} from '../manage-events.slice'
import type { RangeValue, ScopeValue, SessionOption } from '../types'

export let useSessionScope = () => {
  let dispatch = useAppDispatch()
  let scope = useAppSelector(selectActiveScope)
  let range = useAppSelector(selectActiveRange)
  let singleSession = useAppSelector(selectActiveSession)
  return {
    scope,
    range,
    singleSession,
    setScope: (v: ScopeValue) => dispatch(activeScopeSet(v)),
    setRange: (v: RangeValue) => dispatch(activeRangeSet(v)),
    setSingleSession: (s: SessionOption | null) =>
      dispatch(activeSessionSet(s)),
    reset: () => dispatch(activeScopeSet('upcoming')),
  }
}
